export default {
  getCourierScoreRecord: '/courierScore/client/record'
  // getCourierScoreRecord: 'http://yapi.bingex.com/mock/1026/courierScore/client/record'
}
